import { CustomCategoryHierarchy } from '@catalog/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CatalogState, StateWithCatalog } from '../catalog-state';
import { getCustomCatalogState } from './feature.selector';

type CategoryDetailsState = CatalogState['categoryDetails'];

export const getCategoryDetailsState: MemoizedSelector<StateWithCatalog, CategoryDetailsState> = createSelector(
  getCustomCatalogState,
  (state: CatalogState) => state.categoryDetails,
);

export const getCategoryDetailsValue: MemoizedSelector<StateWithCatalog, CustomCategoryHierarchy> = createSelector(
  getCategoryDetailsState,
  (state: CategoryDetailsState) => StateUtils.loaderValueSelector(state),
);
